import React from 'react'
import styled from 'styled-components'
import Anime from '../Animation/Anime'
import { TARGET_CHILDREN } from '../Animation/Animations'
import { scaleIn, scaleOut, easings } from '../Animation/Animations'
import ImageToCanvas from '../ImageToCanvas'

const CompanyAvatar = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
`

const Mask = styled.div`
  height: 100%;
  transition: clip-path ${props => props.duration}ms 200ms ease-in-out;
  clip-path: circle(${({ size }) => size / 2}px at center);
`

const Canvas = styled(ImageToCanvas)`
  transform: scale(${({ isLarge }) => (isLarge ? 1.1 : 1)});
  transition-property: transform;
  transition-duration: ${props => props.duration}ms;
  transition-timing-function: ease-in-out;
`

export const animation = {
  duration: 1000,
  easing: easings.EASE_IN_OUT_BACK,
  targets: TARGET_CHILDREN,
}

export default ({ image, size, show, placeholder, imageSize }) => {
  return (
    <Anime in={show} enter={scaleIn(animation)} exit={scaleOut(animation)}>
      <CompanyAvatar size={imageSize}>
        <Mask size={size} duration={animation.duration}>
          <Canvas
            url={
              placeholder
                ? `https://source.unsplash.com/random/${imageSize}x${imageSize}`
                : image
            }
            width={imageSize}
            height={imageSize}
            isLarge={imageSize === size}
            duration={animation.duration * 2}
          />
        </Mask>
      </CompanyAvatar>
    </Anime>
  )
}
